import {DatabaseCode, toDatabaseCode} from "./database-code";

export interface TransportRejectionType extends DatabaseCode {
}

const highBSW: TransportRejectionType = {
  code: 'HIGH_BSW',
  displayValue: {
    id: 'ots.ui.entity.transport.rejection.type.highbsw',
    defaultMessage: 'High BS&W',
  },
};

const lowOil: TransportRejectionType = {
  code: 'LOW_OIL',
  displayValue: {
    id: 'ots.ui.entity.transport.rejection.type.lowoil',
    defaultMessage: 'Low Oil',
  },
};

const longWaitTimes: TransportRejectionType = {
  code: 'LONG_WAIT_TIMES',
  displayValue: {
    id: 'ots.ui.entity.transport.rejection.type.longwaittimes',
    defaultMessage: 'Long Wait Times',
  },
};

const equipIssues: TransportRejectionType = {
  code: 'EQUIP_ISSUES',
  displayValue: {
    id: 'ots.ui.entity.transport.rejection.type.equipissues',
    defaultMessage: 'Equipment Issues',
  },
};

const highH2S: TransportRejectionType = {
  code: 'HIGH_H2S',
  displayValue: {
    id: 'ots.ui.entity.transport.rejection.type.highh2s',
    defaultMessage: 'High H2S',
  },
};

const other: TransportRejectionType = {
  code: 'OTHER',
  displayValue: {
    id: 'ots.ui.entity.transport.rejection.type.other',
    defaultMessage: 'Other',
  },
};

export const transportRejectionType = {
  highBSW,
  lowOil,
  longWaitTimes,
  equipIssues,
  highH2S,
  other,
};

export const transportRejectionTypes = Object.values(transportRejectionType);

export const toTransportRejectionType = (code: string): TransportRejectionType => toDatabaseCode(code, transportRejectionTypes);
